import { render, staticRenderFns } from "./mainSimilar.vue?vue&type=template&id=28770700&scoped=true"
import script from "./mainSimilar.vue?vue&type=script&lang=js"
export * from "./mainSimilar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28770700",
  null
  
)

export default component.exports